import { Box, Flex, Text, Heading, Image, Stack, HStack, Circle } from '@chakra-ui/react';

import { useEffect, useState } from 'react';

import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import AnnounceImage from '../../../../assets/images/AnnouncementImage.jpg';

import MyDiv from './announcementCard.style';
import { showDate } from '../../../../utilities/helper';

const AnnouncementCarousel = ({ reload, branch }: { reload: boolean, branch?: number[] }) => {
  const [announcements, setAnnouncements] = useState<any[]>([]);
  const [index, setIndex] = useState(0);
  const current = announcements[index];
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [showMore, setShowMore] = useState(false);
  const limit = 500;

  useEffect(() => {
    if (announcements.length > 1 && !showMore) {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % announcements.length);
      }, 4000);
      return () => clearInterval(interval);
    }

  }, [announcements, showMore]);


  const loadAnnoucement = async () => {
    const params = new URLSearchParams();

    if (branch && branch.length > 0) {
      branch.forEach((b) => params.append("branch", b.toString()));
    } else {
      params.append("branch", "0");
    }

    const response = await fetchApi("dashboard/getAnnouncement", "GET", null, params.toString(), "");
    if (response) {
      setAnnouncements(response);
    }
  };

  useEffect(() => {
    loadAnnoucement()
  }, [reload, branch]);

  const getImageUrl = (fileName?: string | null): string => {
    return fileName ? fileName : AnnounceImage;
  };

    const formatDate = (dateStr?: string) => {
  if (!dateStr) return "";
  return dateStr.split("T")[0];
};

  const text = current?.description || "";

  return (
    <MyDiv>
      <Box>
        <Heading fontSize="lg" mb={3}>Announcement</Heading>

        <Flex className="slider-box common_bg">

          <Image src={getImageUrl(current?.file_Name)} fallbackSrc={AnnounceImage} alt="Announcement" w="280px" h="250px" objectFit="fill"
            rounded="md" />

          <Box className="slider-card">

            {announcements.length === 0 ? (
              <Flex justify="center" align="center" minH="200px" color="gray.500">
                <Text className="font-poppins text_regular text_md">
                  No Announcement Available.
                </Text>
              </Flex>
            ) : (
              <Stack>

                <Flex justifyContent="space-between">
                  <Text className='font-poppins text_lg text_medium'>{current?.name}</Text>
                  <Text  color="gray.500" className='font-poppins text_sm text_regular'>
                     {showDate(current?.date)}
                  </Text>
                </Flex>

                <Text className='font-poppins text_lg text_semibold'>{current?.topic}</Text>

                {/* ----------------- DESCRIPTION WITH SHOW MORE ----------------- */}
                <Box mt={2}>
                  <Text fontSize="sm" color="gray.700" className="font-poppins">
                    {
                      !showMore
                        ? text.substring(0, limit) + (text.length > limit ? "... " : "")
                        : text + " "
                    }

                    {text.length > limit && (
                      <Text
                        as="span"
                        color="blue.500"
                        cursor="pointer"
                        fontWeight="medium"
                        onClick={() => setShowMore(!showMore)}
                      >
                        {showMore ? "Show less" : "Show more"}
                      </Text>
                    )}
                  </Text>
                </Box>


              </Stack>
            )}

            {/* Slider Dots */}
            <Box position="sticky" >
              <HStack spacing={2} className="slider-dots" position="absolute">
                {announcements?.map((_, i) => (
                  <Circle
                    key={i}
                    className={`dot ${i === index ? 'active' : ''}`}
                    cursor="pointer"
                    onClick={() => setIndex(i)}
                  />
                ))}
              </HStack>
            </Box>
          </Box>

        </Flex>

      </Box>
    </MyDiv>
  );
};

export default AnnouncementCarousel;
